import React from 'react';
import { defaultPaginationConfig } from '../../../common/constants/config-defaults';
import { useApi } from '../../api-provider';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { Ordering } from '../../../common/common-enums';
import { useTranslate } from '../../context/api-context/translations/use-translate';
export const useCommentsSort = () => {
    var _a, _b, _c;
    const { resourceId, pagination = defaultPaginationConfig, ctxFields, reactions, ratings, } = useConfiguration();
    const { changeOrdering } = useApi((_state, actions) => ({
        changeOrdering: actions.changeOrdering,
    }));
    const t = useTranslate();
    const withVotes = ((_a = reactions === null || reactions === void 0 ? void 0 : reactions.commentReactions) === null || _a === void 0 ? void 0 : _a.type) === 'votes';
    const withReactions = ((_b = reactions === null || reactions === void 0 ? void 0 : reactions.commentReactions) === null || _b === void 0 ? void 0 : _b.type) === 'emotions' ||
        ((_c = reactions === null || reactions === void 0 ? void 0 : reactions.commentReactions) === null || _c === void 0 ? void 0 : _c.type) === 'likes';
    const withRatings = Boolean(ratings);
    const sortOptions = React.useMemo(() => [
        {
            id: Ordering.NEWEST_FIRST,
            value: t('comments-ordering.latest-first'),
            isSelectable: true,
        },
        {
            id: Ordering.OLDEST_FIRST,
            value: t('comments-ordering.oldest-first'),
            isSelectable: true,
        },
        ...(withReactions
            ? [
                {
                    id: Ordering.MOST_REACTIONS_FIRST,
                    value: t('comments-ordering.most-reactions-first'),
                    isSelectable: true,
                },
            ]
            : []),
        ...(withVotes
            ? [
                {
                    id: Ordering.MOST_VOTES_FIRST,
                    value: t('comments-ordering.descending-first'),
                    isSelectable: true,
                },
                {
                    id: Ordering.LEAST_VOTES_FIRST,
                    value: t('comments-ordering.ascending-first'),
                    isSelectable: true,
                },
            ]
            : []),
        ...(withRatings
            ? [
                {
                    id: Ordering.HIGHEST_RATED_FIRST,
                    value: t('comments-ordering.most-rated-first'),
                    isSelectable: true,
                },
                {
                    id: Ordering.LOWEST_RATED_FIRST,
                    value: t('comments-ordering.least-rated-first'),
                    isSelectable: true,
                },
            ]
            : []),
    ], [t, withReactions, withVotes, withRatings]);
    const onSortChange = React.useCallback((ordering) => {
        return changeOrdering({
            resourceId,
            pagination,
            ctxFields,
            ordering: ordering,
            withVotes,
            withRatings,
        });
    }, [resourceId, pagination, ctxFields, changeOrdering, withVotes, withRatings]);
    return { sortOptions, onSortChange };
};
//# sourceMappingURL=use-comments-sort.js.map